<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == `${to.meta.abrev}-regiao` || to.name == 'regioes') {
            next({ name: `${to.meta.abrev}-regiao-list` });
        } else {
            next();
        }
    },
    created() {
        if (
            this.$route.name == `${this.$route.meta.abrev}-regiao` ||
            this.$route.name == 'regioes'
        ) {
            this.$router.push({ name: `${this.$route.meta.abrev}-regiao-list` });
        }
    },
};
</script>
